export default __webpack_public_path__ + "media/zurb/img/legacy/reel/instructions-1-817f03ffbe9e2d592b9e553a6ff67dc7.png";